import React from 'react';

const LoveIcon = () => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.449707"
      y="0.16748"
      width="47.0427"
      height="47.0427"
      rx="23.5214"
      fill="#0A3887"
    />
    <path
      d="M13.7605 23.8192H31.2563L30.3256 24.5637L21.817 16.002H24.476L33.1707 24.7765L24.4494 33.551H21.7905L30.3256 24.9892L31.2563 25.7337H13.7605V23.8192Z"
      fill="white"
    />
  </svg>
);

export default LoveIcon;
